const utils = {
  install: function (Vue) {

    /**
     * 按指定对象属性对对象数组进行排序
     * @param {string} prop 排序字段
     * @param {number} resv 排序类型
     * @returns {Array} 排序后的数组
     * @public
     */
    Array.prototype.sortBy = function (prop, resv) {
      if (resv == undefined) {
        resv = 1;
      } else {
        resv = (resv) ? 1 : -1;
      }

      return this.sort(function (a, b) {
        let value1 = a[prop];
        let value2 = b[prop];

        if (value1 < value2) {
          return resv * -1;
        }
        if (value1 > value2) {
          return resv * 1;
        }

        return 0;
      });
    }
    /**
     * 查找指定的元素在数组中的位置
     */
    Array.prototype.indexOf = function (val) {
      for (var i = 0; i < this.length; i++) {
        if (this[i] == val) return i;
      }
      return -1;
    };
    /**
     * 删除这个元素
     */
    Array.prototype.remove = function (val) {
      var index = this.indexOf(val);
      if (index > -1) {
        this.splice(index, 1);
      }
    };
    /**
     * 按指定格式对时间进行格式化
     * @param {string} 格式化字符串
     * @returns {string} 格式化后的时间字符串
     * @public
     */
    Date.prototype.format = function (fmt) {
      var o = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "h+": this.getHours() % 12 == 0 ? 12 : this.getHours() % 12,
        "H+": this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "q+": Math.floor((this.getMonth() + 3) / 3),
        "S": this.getMilliseconds()
      };
      var week = {
        "0": "/u65e5",
        "1": "/u4e00",
        "2": "/u4e8c",
        "3": "/u4e09",
        "4": "/u56db",
        "5": "/u4e94",
        "6": "/u516d"
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? "/u661f/u671f" : "/u5468") : "") + week[this.getDay() + ""]);
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
      }
      return fmt;
    }

    /**
     * 将UTF-8的Byte数组转换为字符串
     * @param {Array} arr UTF-8的Byte数组
     * @returns {string} 转换后字符串
     * @public
     */
    Vue.prototype.UTF8BytesToString = function (arr) {
      var decodeStr = "";
      if ("TextDecoder" in window) {
        var dataView = new DataView(arr);
        var decoder = new TextDecoder("utf8");
        decodeStr = decoder.decode(dataView);
      } else {
        var decodedString = String.fromCharCode.apply(
          null,
          new Uint8Array(arr)
        );
        decodeStr = decodeURIComponent(escape(decodedString));
      }

      return decodeStr;
    }
  }
}

export default utils



// WEBPACK FOOTER //
// ./src/js/utils.js